module.exports = __webpack_public_path__ + "media/images/aloe/illustrations/metrics-c445d01b514f959d25651b7154a7e5d8.svg";